import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import type { HereGeocodeItem } from '@sbt-web/network/types';
import { Palette } from '@sbt-web/ui';
import loadHereCode from './here-loader';
import ownClasses from './FilterMap.module.css';
declare const window: typeof globalThis & typeof Window & {
  H?: typeof H;
};
interface Props {
  selectedPoint?: Pick<HereGeocodeItem, 'position'>;
  radius: number;
}
const centreOfItaly = {
  lat: 41.87194,
  lng: 12.56738
};
const defaultZoom = 4.2;
const HereMap = t0 => {
  const $ = _c(15);
  const {
    selectedPoint,
    radius
  } = t0;
  const mapRef = useRef(null);
  const [hereCodeLoaded, setHereCodeLoaded] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      loadHereCode(setHereCodeLoaded);
    };
    t2 = [setHereCodeLoaded];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const [hereMap, setHereMap] = useState(null);
  let t3;
  let t4;
  if ($[2] !== hereCodeLoaded) {
    t3 = () => {
      if (!mapRef.current) {
        return;
      }
      if (hereCodeLoaded) {
        const H = window.H;
        const platform = new H.service.Platform({
          apikey: process.env.NEXT_PUBLIC_HERE_WEB_KEY
        });
        const defaultLayers = platform.createDefaultLayers({
          ppi: 250,
          lg: "it-IT",
          crossOrigin: "anonymous"
        });
        const hm = new H.Map(mapRef.current, defaultLayers.vector.normal.map, {
          padding: {
            top: 24,
            right: 24,
            bottom: 24,
            left: 24
          },
          pixelRatio: window.devicePixelRatio || 1,
          center: centreOfItaly,
          zoom: defaultZoom
        });
        setHereMap(hm);
        return () => {
          hm.dispose();
        };
      }
    };
    t4 = [hereCodeLoaded, setHereMap];
    $[2] = hereCodeLoaded;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useLayoutEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== hereMap || $[6] !== selectedPoint) {
    t5 = () => {
      if (hereMap == null) {
        return;
      } else {
        if (selectedPoint == null || selectedPoint.position?.lat == null || selectedPoint.position?.lng == null) {
          hereMap?.setCenter(centreOfItaly).setZoom(defaultZoom);
          return;
        }
      }
      hereMap.setCenter({
        lat: selectedPoint.position.lat,
        lng: selectedPoint.position.lng
      });
    };
    t6 = [hereMap, selectedPoint];
    $[5] = hereMap;
    $[6] = selectedPoint;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[9] !== hereMap || $[10] !== radius || $[11] !== selectedPoint) {
    t7 = () => {
      if (hereMap == null || selectedPoint == null || selectedPoint.position?.lat == null || selectedPoint.position?.lng == null) {
        return;
      }
      const circle = new window.H.map.Circle({
        lat: selectedPoint.position.lat,
        lng: selectedPoint.position.lng
      }, radius, {
        style: {
          lineWidth: 2,
          strokeColor: Palette.PurpleImmobili,
          fillColor: "rgba(162, 89, 255, 0.1)"
        }
      });
      hereMap.addObject(circle);
      hereMap.getViewModel().setLookAtData({
        bounds: circle.getBoundingBox()
      });
      return () => {
        if (hereMap?.getObjects().includes(circle)) {
          hereMap.removeObject(circle);
        }
      };
    };
    t8 = [hereMap, radius, selectedPoint];
    $[9] = hereMap;
    $[10] = radius;
    $[11] = selectedPoint;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={classnames(ownClasses["here-map"])} ref={mapRef} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default HereMap;